import React from "react";

import { useTranslation } from "react-i18next";

import { EmptyStateCard, EmptyStateCardBody, EmptyStateTitle, EmptyStateSubtitle } from "./styles";

const EMPTY_STATE_IMG = require("../../../../../../../../../../../../assets/img/empty-state-grid.svg");

export const EmptyState: React.FC = () => {
  const { t: translate } = useTranslation();

  return (
    <div>
      <EmptyStateCard>
        <img src={EMPTY_STATE_IMG} />
        <EmptyStateCardBody>
          <EmptyStateTitle>{translate("itLooksLikeNoOrderWasSelectYet")}</EmptyStateTitle>
          <EmptyStateSubtitle>
            {translate("startSearchingForAnOrderToBeAbleToCreateANewTask")}
          </EmptyStateSubtitle>
        </EmptyStateCardBody>
      </EmptyStateCard>
    </div>
  );
};
